import React from "react";
import EyeTracker from "./components/EyeTracker";  
function App() {
  return (  <div> <EyeTracker /> </div> );}export default App;
